import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['selectable-table']
  static targets = ['actions', 'allSelector']

  changeAll(selected) {
    this.selectableTableOutlet.changeAll(this.allSelectorTarget.checked)
  }

  selectionChanged() {
    this.allSelectorTarget.checked =
      !this.selectableTableOutlet.hasUnselectedRows()

    this.actionsTarget.classList
      .toggle('some-selected', this.selectableTableOutlet.hasSelectedRows())
  }
}
